<template>
  <div class="container">
    <div class="column">
      <div class="card-items">
        <div class="card-item" v-for="(item, index) in items" :key="index">
          <div class="card-video">
            <img :src="item.poster" />
            <div class="ico-play" @click="playVideo(item)"></div>
          </div>
          <div class="card-item-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <div class="video-modal" v-show="isShowModal">
      <div class="modal"></div>
      <div class="video-container" ref="player">
        <div class="player" id="player"></div>
        <div class="close" @click="close">关闭</div>
      </div>
    </div>
  </div>
</template>
<script>
import Player from "xgplayer";
import { originUrl } from "@/utils";
export default {
  data() {
    return {
      Player: null,
      isShowModal: false,
      items: [
        {
          url: `${originUrl}fs-sm/video/方舱医院采访·孙总.mp4`,
          poster: require("@/assets/images/newsCenter/adv1.png"),
          title: "新华网系列报道：方舱医院"
        },
        {
          url: `${originUrl}fs-sm/video/智慧社区·孙总.mp4`,
          poster: require("@/assets/images/newsCenter/adv2.png"),
          title: "新华网系列报道：智慧社区"
        },
        {
          url: `${originUrl}fs-sm/video/戴尔科技峰会.mp4`,
          poster: require("@/assets/images/newsCenter/adv3.png"),
          title: "人民网：全景智联对话戴尔，以科技之名，致敬攀登者"
        }
      ]
    };
  },
  methods: {
    playVideo(item) {
      this.isShowModal = true;
      this.initPlayer(item.url);
    },
    initPlayer(url) {
      this.$nextTick(res => {
        this.Player = new Player({
          // el、url为必选配置，其它为可选配置
          id: "player",
          url: url,
          width: "100%",
          height: "100%",
          volume: 0.6, // 初始音量
          autoplay: true, // 自动播放
          fitVideoSize: "auto",
          // fluid: true,
          playbackRate: [0.5, 0.75, 1, 1.5, 2], // 当前播放速度
          defaultPlaybackRate: 1 // 播放速度设置为1
        });
      });
    },
    close() {
      this.isShowModal = false;
      this.Player.destroy(this.$refs["player"]);
    }
  }
};
</script>
<style lang="less" scoped>
.column {
  padding: 7.55rem 11.5rem 6rem;
  background-color: #f2f3f5;
  .card-items {
    display: flex;
    justify-content: space-between;
    .card-item {
      flex: 0 0 22.9rem;
      margin: 0 1.1rem;
      .card-video {
        position: relative;
        width: 22.9rem;
        height: 12.8rem;
        overflow: hidden;
        &:hover {
          img {
            transform: scale(1.1);
          }
          .ico-play {
            display: block;
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
            transition: all 0.6s ease-in;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        .ico-play {
          opacity: 0;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 3.41rem;
          height: 3.41rem;
          background-image: url("~@/assets/images/newsCenter/ico_play.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          transform: translate(-50%, -50%) scale(1.3);
          cursor: pointer;
        }
      }
      .card-item-title {
        height: 7.7rem;
        padding: 2.2rem 1.7rem 0 2rem;
        font-size: 1.2rem;
        font-weight: bold;
        line-height: 1.65rem;
        color: #000000;
        background-color: #ffffff;
      }
    }
  }
}
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 9998;
  .modal {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
  }
  .video-container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 64rem;
    height: 36rem;
    z-index: 10000;
    transform: translate(-50%, -50%);
    .close {
      position: absolute;
      top: 0;
      right: -56px;
      padding: 0 10px;
      font-size: 0.9rem;
      color: #d4d1d1;
      cursor: pointer;
    }
  }
}
</style>
